import { Link } from "react-router-dom";
import { getCategories } from "@/lib/news";

export default function SiteFooter() {
  const categories = getCategories();

  return (
    <footer className="mt-16 w-full bg-secondary-900 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill"></i>
              </span>
              <span className="font-heading text-lg font-black">
                <span className="text-accent-400">91</span>
                <span className="text-background-50">爆料</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-400">
              致力于提供最新最热的社会热点新闻与独家爆料报道，覆盖娱乐、时政、科技等多个领域，实时更新、直击内幕。
            </p>
            <div className="mt-4 flex gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-share-forward-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-background-300 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">新闻分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-background-400 transition-colors hover:text-accent-400"
                  >
                    {cat.name}新闻
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-400 transition-colors hover:text-accent-400">
                  搜索新闻
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-400 transition-colors hover:text-accent-400">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">联系方式</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>contact@91baoliao.example.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <span>400-091-8896（工作日 9:00-18:00）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>北京市朝阳区新闻大厦 A 座 18 层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91爆料 · 本站内容均为演示数据，不构成任何真实报道</p>
          <p className="flex flex-wrap items-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-accent-400">隐私政策</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">服务条款</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}